// Scoring
export { default as getWeight } from './get-weight';
export { default as getScore } from './get-score';
export { default as scoreCommas } from './score-commas';
export { default as scoreLength } from './score-length';
export { default as scoreParagraph } from './score-paragraph';
export { default as setScore } from './set-score';
export { default as addScore } from './add-score';
export { default as addToParent } from './add-to-parent';
export { default as getOrInitScore } from './get-or-init-score';
export { default as scoreNode } from './score-node';
export { default as scoreContent } from './score-content';
export { default as findTopCandidate } from './find-top-candidate';
